import React from "react";

const DeleteAccount = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="w-full max-w-2xl bg-white rounded-lg shadow-md p-8">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">
          Delete Your Account
        </h1>

        <p className="text-gray-700 mb-4">
          If you would like to delete your account and associated personal
          data, please send an email to{" "}
          <a
            href="mailto:support@dlearners.in"
            className="text-blue-600 font-semibold"
          >
            support@dlearners.in
          </a>{" "}
          using the email address or mobile number registered with your
          account.
        </p>

        <p className="font-semibold text-gray-800 mb-2">
          Please include:
        </p>

        <ul className="list-disc list-inside text-gray-700 mb-6 space-y-2">
          <li>Registered email address or mobile number</li>
          <li>Your request to delete your account</li>
        </ul>

        <p className="text-gray-700 mb-4">
          Your account deletion request will be processed within{" "}
          <strong>24–48 hours</strong>.
        </p>

        <p className="text-gray-700">
          Once the request is processed, your account and associated data will
          be deleted, except for information that we are legally required to
          retain.
        </p>
      </div>
    </div>
  );
};

export default DeleteAccount;